interface FlakeIdOptions {
  epoch?: number;
  id?: number;
}

class FlakeId {
  private epoch: number;
  private id: number;
  private sequence: number = 0;
  private lastTime: number = -1;

  constructor(options: FlakeIdOptions = {}) {
    this.epoch = options.epoch ?? 1300000000000;
    this.id = options.id ?? Math.floor(Math.random() * 1025);
  }

  /**
   * 生成下一个ID
   * @returns {bigint} 64位唯一ID
   */
  public next(): bigint {
    const time = Date.now();

    if (time < this.lastTime) {
      throw new Error('Clock moved backwards');
    }

    if (time === this.lastTime) {
      this.sequence = (this.sequence + 1) & 0xFFF; // 12位序列号
      if (this.sequence === 0) {
        return this.next()
      }
    } else {
      this.sequence = 0;
    }

    this.lastTime = time;

    // 组成64位ID
    const timestamp = BigInt(time - this.epoch) << 22n;  // 42位时间戳
    const machineId = BigInt(this.id & 0x3FF) << 12n;    // 10位机器ID
    const seq = BigInt(this.sequence);                    // 12位序列号

    return timestamp | machineId | seq;
  }
}
const flakeNode = new FlakeId({
  epoch: 1300000000000,
  id: Math.floor(Math.random() * (1024 + 1))
});


export const guuid = () => {
  const value = flakeNode.next().toString(10);
  return value;
};